import { Injectable } from '@angular/core';
import { Moment } from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DashboardFilterStateService {
  dateRange: { start: Moment | null; end: Moment | null } | null = null;

  getDateRange(){
    return this.dateRange;
  }

  setDateRange(start: Moment | null, end: Moment | null) {
    this.dateRange = { start, end };
  }

  clear() {
    this.dateRange = null;
  }
}
